<template>
<div :class="itemId != 0?'marginTop32':'paddingTop88'">
    <header class="headerBtnBox">
            <!-- <span class="backBtn el-icon-arrow-left" v-if="itemId != 0" @click="goBackItem"></span> -->
            <span class="projectNameBox">{{projectName}}</span>
            <el-button v-for="item in headerTypeArr" :key="item.id" :class="formData.contestType == item.id ? 'activeHeader' : ''" @click="changeHeaderType(item)" :autofocus="item.dictCont == '投影'"> {{item.dictCont == '显示照明'?'屏类':item.dictCont}}</el-button>
    </header>
    <div class="realityQueryBox box80">
        <el-form :inline="true" :model="serachJson" class="demo-form-inline">
        <el-form-item label="灯具类型" prop="region">
            <el-select v-model="serachJson.lampType" placeholder="灯具类型">
                <el-option v-for="item in lampTypeOption" :key="item.id" :label="item.dictCont" :value="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="动态效果" v-if="headerType ==3" class="min20">
            <el-input  v-model="serachJson.dynamicEffect"></el-input>
        </el-form-item>
        <el-form-item label="水纹纹理" v-if="headerType ==4" class="min20">
            <el-input v-model="serachJson.waterTexture"></el-input>
        </el-form-item>
        <el-form-item label="光通量" v-if="headerType ==1" class="min20">
            <el-input type="number" v-model="serachJson.luminousFluxMin"></el-input>～
            <el-input type="number" v-model="serachJson.luminousFluxMax"></el-input>
        </el-form-item>
        <el-form-item label="灯具功率" class="min20">
            <el-input type="number" v-model="serachJson.lumPowerMin"></el-input>～
            <el-input type="number" v-model="serachJson.lumPowerMax"></el-input>
        </el-form-item>
        <el-form-item label="横向点间距" v-if="headerType ==2" class="min20">
            <el-input type="number" v-model="serachJson.pointSpacingH"></el-input>
        </el-form-item>
        <el-form-item label="竖向点间距" v-if="headerType ==2" class="min20">
            <el-input type="number" v-model="serachJson.pointSpacingV"></el-input>
        </el-form-item>
        <el-form-item label="安装位置" v-if="headerType ==2" class="min80">
           <!-- <el-input v-model="serachJson.installationPosition"></el-input>-->
            <el-select v-model="serachJson.installationPosition" placeholder="安装位置">
                <el-option v-for="item in InstallationPositionArr" :key="item.id" :label="item.dictCont" :value="item.id"></el-option>
            </el-select>

        </el-form-item>
        <!-- 视看距离 -->
        <el-form-item label="观看距离" v-if="headerType ==2" class="min20">
            <el-input type="number"  v-model="serachJson.viewingDistance"></el-input>
        </el-form-item>
        <el-form-item label="载体类型" v-if="headerType != 2">
            <el-select v-model="serachJson.carrierType" placeholder="载体类型">
                <el-option v-for="item in carrierTypeOption" :key="item.id" :label="item.dictCont" :value="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="被照面高度" v-if="headerType !=2" class="min20">
            <el-input v-model="serachJson.illuminationHMin"></el-input>～
            <el-input v-model="serachJson.illuminationHMax"></el-input>
        </el-form-item>
        <el-form-item label="被照面宽度" v-if="headerType !=2" class="min20">
            <el-input type="number" v-model="serachJson.illuminationWMin"></el-input>～
            <el-input type="number" v-model="serachJson.illuminationWMax"></el-input>
        </el-form-item>
        <el-form-item label="投射距离" v-if="headerType !=2 && headerType !=4" class="min20">
            <el-input type="number" v-model="serachJson.projectionDistance"></el-input>
        </el-form-item>
        <el-form-item label="设计亮度" v-if="headerType !=1" class="min20">
            <el-input type="number" v-model="serachJson.designBrightness"></el-input>
        </el-form-item>
        <el-form-item label="设计照度" v-if="headerType == 1" class="min20">
            <el-input type="number" v-model="serachJson.designIlluminationMin"></el-input>~
            <el-input type="number" v-model="serachJson.designIlluminationMax"></el-input>
        </el-form-item>
        <el-form-item label="填写人">
            <el-input v-model="serachJson.createName"></el-input>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="searchTableList">搜索</el-button>
        </el-form>
        <div class="operateBtnBox" v-if="itemId != 0">
            <el-row>
                <el-button type="primary" plain @click="changeInfoVisible(true)">添加</el-button>
                <el-button type="warning" plain @click="editItem">修改</el-button>
                <el-button type="danger" plain @click="deleteItem">删除</el-button>
            </el-row>
        </div>
        <div class="tableBox">
            <el-table
            :data="showTableList"
            ref="tableRef"
            border
            highlight-current-row
            @select="selectRow"
            @select-all="selectAll"
            :max-height="dsdaws"
            style="width: 100%"
            @sort-change="sortChange" 
            :default-sort="sortRule"
            :row-class-name="rowStyle">
                <el-table-column
                type="selection"
                @click.stop
                width="55">
                </el-table-column>
                <el-table-column 
                v-for="(item,index) in tableData[headerType]"
                sortable
                :prop="item.attrIndex"
                :label="item.attrName"
                :key="index"
                width="150"
                :fixed="item.attrName == '详细信息'?'right':false"
                >
                    <template slot-scope="scope">
                        <span v-if="item.attrName == '详细信息'">
                            <el-button @click.stop="handleClick(scope.row)" type="text" size="small">查看</el-button>                      
                        </span>
                        <span v-else-if="item.attrName == '灯参编号'" class="dengcanbianhao">
                            <span v-for="(subItem,index) in scope.row.lampparamNoStr.split(',')" :key="subItem" @click.stop="lookDetailInfo(scope.row.lampparamId,index)">{{subItem}}</span>                      
                        </span>
                        <span v-else-if="item.attrName == '灯具类型' || item.attrName == '载体类型'">
                            <span>{{scope.row[item.attrIndex + 'Str']}}</span>                      
                        </span>
                        <span v-else-if="item.valType != 'image'">
                            <span>{{scope.row[item.attrIndex]}}</span>                       
                        </span>
                        <div class="tableImgBox" v-else>
                            <el-carousel :autoplay="false" indicator-position="outside" v-if="scope.row.photoLandingEffect
.length > 1">
                                <el-carousel-item v-for="item in scope.row.photoLandingEffect
" :key="item">
                                    <el-image 
                                     class="tableImg"
                                        :src="item" 
                                        :preview-src-list="scope.row.photoLandingEffect">
                                    </el-image>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div style="padding:10px;text-align:center">
                <el-pagination
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[20, 50, 100, 200]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="showTableList.length"
                ></el-pagination>
            </div>
        </div>
         <div class="infoMaskBox" v-if="infoVisible">
            <el-dialog 
            @close="closeDialog"
            :visible.sync="infoVisible"
            width="1522px">
            <AddRealityQueryVue :formData="formData" :editLook="editLook" :headerType="headerType" ref="addReality" :itemId="itemId"/>
            <div slot="footer" class="dialog-footer" v-if="editLook != 2">
               <div v-if="editLook == 0">
                    <el-button @click="save(1)" type="primary">保存</el-button>
                    <el-button @click="save(2)" type="primary">保存并关闭</el-button>
               </div>
                <div v-else>
                     <el-button @click="save(3)" type="primary">修改</el-button>
                    <el-button @click="save(4)" type="primary">修改并关闭</el-button>
                </div>
            </div>
            </el-dialog>
         </div>
         <div>
            <RealityQueryDetailPdf ref="realityQueryDetailPdf"/>
         </div>
    </div>
</div>
</template>
<script>
import AddRealityQueryVue from './addRealityQuery.vue';
import RealityQueryDetailPdf from './realityQueryDetailPdf.vue';
export default {
    props:{
        itemId:{
            default:null
        }
    },
  data() {
    return {
        formData:{
            // 项目id
            projectId:'',
            // 应用类型 默认投影id
            contestType:1646,
            // 载体类型
            carrierType:'',
            // 反射率
            reflectivity:'',
            // 光环境亮暗
            lightEnvironment:'',
            // 被照面高度
            illuminationH:'',
            // 被照面宽度
            illuminationW:'',
            // 投射距离
            projectionDistance:'',
            // 设计亮度
            designBrightness:'',
            // 设计照度
            designIllumination:'',
            // 实测亮度
            measuredBrightness:'',
            // 实测照度
            measuredIlluminance:'',
            // 实测均匀度
            measuredUniformity:'',
            // 灯参编号
            lampparamId:'',
            // 光通量
            luminousFlux:'',
            // 灯具类型
            lampType:'',
            // 灯具品牌
            lampBand:'',
            // 灯具型号
            lampMode:'',
            // 灯具功率
            lampPower:'',
            // 灯具数量
            lampsNumber:'',
            // 是否互动
            interactiveFlag:'',
            // 互动类型
            interactiveType:'',
            // 目视效果评价
            visualEffectEva:'',
            // 原因说明
            reasonDescription:[],
            // 投影点位图
            projectionPointBitmap:[],
            // 实测数据伪色图
            picMeasuredColor:[],
            // 落地效果视频
            videoLandingEffect:[],
            // 落地效果照片
            photoLandingEffect:[],
        },
        // 项目名称
        projectName:'',
        // 详细信息弹窗
        infoVisible:false,
        headerTypeArr:[],
        // 顶部类型 1投影 2屏类 3团案 4水纹
        headerType: 1,
        // 灯具类型
        lampTypeOption:[],
        // 载体类型
        carrierTypeOption:[],

        // 安装位置
        InstallationPositionArr:[],
        // 搜索数据
        serachJson:
        {
            //灯具类型
            lampType:'',
            // 光通量
            guangTongLiangMin:'',
            guangTongLiangMax:'',
            // 灯具功率
            lumPowerMin:'',
            lumPowerMax:'',
            // 载体类型
            carrierType:'',
            // 被照面高度
            illuminationHMin:'',
            illuminationHMax:'',
            // 被照面宽度
            illuminationWMin:'',
            illuminationWMax:'',
            // 投射距离
            projectionDistance:'',
            // 设计照度
            designIllumination:'',
            // 填写人
            createName:'',
            // 横向点间距
            pointSpacingH:'',
            //竖向点间距
            pointSpacingV:'',
            // 安装位置
            installationPosition:'',
            // 视看距离 观看距离
            viewingDistance:'',
            // 设计亮度
            designBrightness:'',
            // 动态效果
            dynamicEffect:'',
            // 水纹纹理
            waterTexture:'',
            // 投射距离
            projectionDistance:''
        },
        tableData:{
            1:[
                {
                    attrIndex:"lampType",
                    attrName:"灯具类型",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"luminousFlux",
                    attrName:"光通量",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"lampPower",
                    attrName:"灯具功率",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"interactiveFlag",
                    attrName:"是否互动",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"interactiveType",
                    attrName:"互动类型",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"carrierType",
                    attrName:"载体类型",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"illuminationH",
                    attrName:"被照面高度",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"illuminationW",
                    attrName:"被照面宽度",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"projectionDistance",
                    attrName:"投射距离",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"designIllumination",
                    attrName:"设计照度",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"measuredIlluminance",
                    attrName:"实测照度",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"measuredUniformity",
                    attrName:"实测均匀度",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"lampsNumber",
                    attrName:"灯具数量",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"lampBand",
                    attrName:"灯具品牌",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"lampparamId",
                    attrName:"灯参编号",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"photoLandingEffect",
                    attrName:"落地照片",
                    valType:'image',
                    searchType:1
                },
                {
                    attrIndex:"visualEffectEva",
                    attrName:"目视效果",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"projectName",
                    attrName:"项目名称",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"createName",
                    attrName:"填写人",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"detail",
                    attrName:"详细信息",
                    valType:'button',
                    searchType:1
                },
            ],
            2:[
                {
                    attrIndex:"lampType",
                    attrName:"灯具类型",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"lampPower",
                    attrName:"灯具功率",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"pointSpacingH",
                    attrName:"横向点间距",
                    valType:'number',
                    searchType:2
                },
                {
                    attrIndex:"pointSpacingV",
                    attrName:"竖向点间距",
                    valType:'number',
                    searchType:2
                },
                {
                    attrIndex:"installationPosition",
                    attrName:"安装位置",
                    valType:'number',
                    searchType:2
                },
                {
                    attrIndex:"viewingTime",
                    attrName:"观看时间",
                    valType:'number',
                    searchType:2
                },
                {
                    attrIndex:"viewingDistance",
                    attrName:"视看距离",
                    valType:'number',
                    searchType:2
                },
                {
                    attrIndex:"designBrightness",
                    attrName:"设计亮度",
                    valType:'number',
                    searchType:2
                },
                {
                    attrIndex:"measuredBrightness",
                    attrName:"实测亮度",
                    valType:'number',
                    searchType:2
                },
                {
                    attrIndex:"lampBand",
                    attrName:"灯具品牌",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"lampparamId",
                    attrName:"灯参编号",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"photoLandingEffect",
                    attrName:"落地照片",
                    valType:'image',
                    searchType:1
                },
                {
                    attrIndex:"visualEffectEva",
                    attrName:"目视效果",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"projectName",
                    attrName:"项目名称",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"createName",
                    attrName:"填写人",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"detail",
                    attrName:"详细信息",
                    valType:'button',
                    searchType:1
                },
            ],
            3:[
                {
                    attrIndex:"lampType",
                    attrName:"灯具类型",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"dynamicEffect",
                    attrName:"动态效果",
                    valType:'number',
                    searchType:3
                },
                {
                    attrIndex:"lampPower",
                    attrName:"灯具功率",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"carrierType",
                    attrName:"载体类型",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"projectionDistance",
                    attrName:"投射距离",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"illuminationH",
                    attrName:"被照面高度",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"illuminationW",
                    attrName:"被照面宽度",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"designBrightness",
                    attrName:"设计亮度",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"measuredBrightness",
                    attrName:"实测亮度",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"lampBand",
                    attrName:"灯具品牌",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"lampparamId",
                    attrName:"灯参编号",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"photoLandingEffect",
                    attrName:"落地照片",
                    valType:'image',
                    searchType:1
                },
                {
                    attrIndex:"visualEffectEva",
                    attrName:"目视效果",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"projectName",
                    attrName:"项目名称",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"createName",
                    attrName:"填写人",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"detail",
                    attrName:"详细信息",
                    valType:'button',
                    searchType:1
                },
            ],
            4:[
                {
                    attrIndex:"lampType",
                    attrName:"灯具类型",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"waterTexture",
                    attrName:"水纹纹理",
                    valType:'number',
                    searchType:4
                },
                {
                    attrIndex:"lampPower",
                    attrName:"灯具功率",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"carrierType",
                    attrName:"载体类型",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"projectionDistance",
                    attrName:"投射距离",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"illuminationH",
                    attrName:"被照面高度",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"illuminationW",
                    attrName:"被照面宽度",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"designBrightness",
                    attrName:"设计亮度",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"measuredBrightness",
                    attrName:"实测亮度",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"lampBand",
                    attrName:"灯具品牌",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"lampparamId",
                    attrName:"灯参编号",
                    valType:'number',
                    searchType:1
                },
                {
                    attrIndex:"photoLandingEffect",
                    attrName:"落地照片",
                    valType:'image',
                    searchType:1
                },
                {
                    attrIndex:"visualEffectEva",
                    attrName:"目视效果",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"projectName",
                    attrName:"项目名称",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"createName",
                    attrName:"填写人",
                    valType:'text',
                    searchType:1
                },
                {
                    attrIndex:"detail",
                    attrName:"详细信息",
                    valType:'button',
                    searchType:1
                },
            ],
        },
        dsdaws:600,
        page:1,
        showTableList:[],
        // 选中行的id
        activeId:[],
        // 0添加 1修改 2查看
        editLook: 0,
        // 原因说明里的 其他 单独处理
        other:'',
        multipleSelection: [],
      sortRule: { prop: null, order: null },
    }
  },
  created(){
    this.getTableData()
    // 项目id
    this.formData.projectId = this.itemId;
    this.getDictionary();
    // 获取灯具类型筛选项
    this.getDictionarySearch(1);
    // 获取载体类型筛选项
    this.getDictionarySearch(2);
    if(this.itemId){
        this.getItemListName()
    }
  },
  mounted(){
     this.$nextTick(function () {
      this.dsdaws = window.innerHeight - 350;
      let self = this;
      window.onresize = function() {
          self.dsdaws = window.innerHeight - 350
      }
    })
  },
  methods: {
    sortChange(item) {
      //如果不排序了，就恢复到最初的状态
      if (item.order == null) {
        this.getTableData();
      } else {
        var sort = item.prop;
        if(sort == "lumTypeName"){
          sort = "lumType"
        }
        this.serachJson.sort = sort;
        this.serachJson.order = item.order == "ascending" ? "asc" : "desc";
        this.getTableData();
      }
      this.sortRule.order = item.order;
      this.sortRule.prop = item.prop;
    },
    // 格式化大图预览地址
    toArrUrl(arr){
        console.log(arr)
    },
    // 列表图片点击查看大图
    imgClick(imgPath,imgUrl){
        console.log(imgPath,imgUrl)
    },
    // 搜索
    searchTableList(){
        this.getTableData()
    },
    // 点击灯参编号
    lookDetailInfo(item,index){
        this.$refs.realityQueryDetailPdf.show(item.split(',')[index])
    },
    // 修改项目
    editItem(){
        if(this.activeId.length == 0){
            this.$message({
                message: '请先选中一条数据',
                type: 'warning'
            });
        }else if(this.activeId.length > 1){
            this.$message({
                message: '只能选中一条数据',
                type: 'warning'
            });
        }else{
            var itemData = null;
            this.changeInfoVisible(true)
            this.editLook = 1;
            itemData = this.showTableList.filter(e=>{
                return e.id == this.activeId[0]
            })
            itemData = itemData[0]
            Object.assign(this.formData,this.formData,itemData)
            this.formData.reasonDescription = this.formData.reasonDescription.split(',')
            if(this.formData.reasonDescription.length > 0){
                // 包含 其他
                this.formData.reasonDescription.forEach((e,i)=>{
                    if(e.indexOf('E.其他') != -1){ 
                        // 选了 其他 需要单独处理
                        this.$set(this.formData,'other',e.slice(5))
                        this.$set(this.formData.reasonDescription,i,'E.其他')
                        this.$nextTick(()=>{
                            this.$refs.addReality.otherFlag = true
                        })
                        
                    }
                })
            }
        }
    },
    // 关闭弹出框
    closeDialog(){
        for(var item in this.formData){
            if(item == 'projectId' || item == 'contestType'){
                continue
            }
            if(item == 'reasonDescription'){
                this.formData[item] = []
            }else{
                this.formData[item] = ''
            }
        }
    },
    // 删除选中行
    deleteItem(){
        this.$http.post('/api/projectFeedback/batchDelete', {
            ids:this.activeId.toString()
        }, (res)=> {
            if (res.success) {
                this.$message({
                message: "删除成功！",
                type: "success"
                });
                this.getTableData()
            }else{
                this.$message({
                    message: "删除失败！",
                    type: "error"
                });
            }
        })
    },
    // 单选
    selectRow(row){
        this.selectAll(row)
    },
    // 全选
    selectAll(row){
        this.activeId = []
        if(row.length == 0){
            this.activeId = []
        }
        if(row.length > 0){
            for(var i=0;i<row.length;i++){
                this.activeId.push(row[i].id)
            }
        }
    },
    // 选中当前行
    selectItem(item){
        if(this.activeId.indexOf(item.id) == -1){
            this.activeId.push(item.id)
        }else{
            this.activeId.splice(this.activeId.indexOf(item.id),1)
        }
    },
    // 表格添加class
    rowStyle({row}){
      var arr = this.activeId;
      if(arr.indexOf(row.id) != -1){
        return 'rowStyle'
      }
    },
    // 分页
    handleCurrentChange(page) {
        this.page = page;
        this.getTableData()
    },
    // 字典接口调用 1灯具类型 2载体类型

      getLampTypeDictionaryList(){
          this.$http.getSync('/api/dictionaryLampparam/lampparamDictTypeList', {
              indexPinyin:  'dengjuleixing',
              contestType:this.formData.contestType
          }, (res)=> {
              if (res.success) {
                  this.lampTypeOption = res.data
              }
          })

      },

    getDictionarySearch(type){
          if(type==1){
              this.getLampTypeDictionaryList();
          }
        if(type==2){
            this.$http.getSync('/api/dictTypeAllList', {
                indexPinyin:  'zaitileixing'
            }, (res)=> {
                if (res.success) {
                    // 载体类型
                    this.carrierTypeOption = res.data
                }
            })
        }

        //安装位置
        this.$http.getSync('/api/dictTypeAllList', {
            indexPinyin:  'anzhuangweizhi'
        }, (res)=> {
            if (res.success) {
                this.InstallationPositionArr = res.data
            }
        })


    },



    // 顶部四项字典接口调用
    getDictionary(){
        this.$http.getSync('/api/dictTypeAllList', {
            indexPinyin: 'yingyongchangjingleixing'
        }, (res)=> {
            if (res.success) {
                this.headerTypeArr = res.data.filter((e)=>{
                    return e.dictCont == '投影' || e.dictCont == '显示照明' || e.dictCont == '图案' || e.dictCont == '水纹'
                })
            }
        })
    },
    // 保存 type1保存 2保存并关闭 3修改 4修改并关闭
    save(type){
        var url = '/api/projectFeedback/create';
        if(type == 3 || type == 4){
            url = '/api/projectFeedback/update';
        }
        if(this.formData.reasonDescription.indexOf('E.其他') != -1){
            // 原因说明里的 其他 单独处理
            this.formData.reasonDescription = this.formData.reasonDescription.filter(e=>{
                return e != 'E.其他'
            })
            this.formData.reasonDescription.push('E.其他：' + this.formData.other)
        
        }
        // 原因说明
        this.formData.reasonDescription = this.formData.reasonDescription.toString()
        // 投影点位图
        this.formData.projectionPointBitmap = this.formData.projectionPointBitmap.toString()
        // 实测数据伪色图
        this.formData.picMeasuredColor = this.formData.picMeasuredColor.toString()
        // 落地效果视频
        this.formData.videoLandingEffect = this.formData.videoLandingEffect.toString()
        // 落地效果照片
        if(this.formData.photoLandingEffect.length > 0){
            var str = this.ImgPath;
            var reg1 = new RegExp(str, "g");
            for(var i=0;i<this.formData.photoLandingEffect.length;i++){
                this.formData.photoLandingEffect[i] = this.formData.photoLandingEffect[i].replace(reg1, "")
            }
        }
       this.formData.photoLandingEffect = this.formData.photoLandingEffect.toString()
        // 灯参编号
       this.formData.lampparamId = this.formData.lampparamId.toString()
        this.$http.postObj(url,{...this.formData}, (res) => {
            if(res.success){
                this.$message.success(type < 3 ? '保存' : '修改' + "成功");
                if(type == 2 || type == 4){
                    this.changeInfoVisible(false)
                }
                this.getTableData()
            }
        })
    },
    // 展示隐藏详细信息弹窗
    changeInfoVisible(type){
        this.infoVisible = type;
        this.editLook = 0;
    },
    //顶部类型变换
    changeHeaderType(item){
        var num = 1;
        switch(item.dictCont){
            case '投影':
                num = 1
            break;
            case '显示照明':
                num = 2
            break;
            case '图案':
                num = 3
            break;
            case '水纹':
                num = 4
            break;
            default:
                num = 1
        }
        this.headerType = num;
        // 应用类型
        this.formData.contestType = item.id;
        this.getLampTypeDictionaryList()
        this.getTableData()
    },
    // 点击查看列表
    handleClick(row) {
        // 打开详细信息页面
        this.changeInfoVisible(true)
        this.editLook = 2;
        Object.assign(this.formData,this.formData,row)
        this.formData.reasonDescription = this.formData.reasonDescription.split(',')
        debugger
        if(this.formData.reasonDescription.length > 0){
            // 包含 其他
            this.formData.reasonDescription.forEach((e,i)=>{
                if(e.indexOf('E.其他') != -1){ 
                    // 选了 其他 需要单独处理
                    this.$set(this.formData,'other',e.slice(5))
                    this.$set(this.formData.reasonDescription,i,'E.其他')
                    this.$nextTick(()=>{
                        this.$refs.addReality.otherFlag = true
                    })
                    
                }
            })
        }
    },
    // 请求列表数据
    getTableData(){
        var projectid ="";
        if(this.itemId!=null && this.itemId!='0'){
            projectid =  this.itemId ;
        }
        this.$http.postObj('/api/projectFeedback/pageJson', {
            contestType: this.formData.contestType,
            projectId: projectid,
            page: this.page, 
            rows: 10,
            ...this.serachJson
        }, (res)=> {
            this.showTableList = res.data.rows.reverse()

            this.showTableList.forEach(e=>{
                if(e.photoLandingEffect.length > 1){
                    e.photoLandingEffect = e.photoLandingEffect.split(',').map(ele=>{
                        return ele = this.ImgPath + ele
                    })
                }
            })
        });
    },
    // 返回原页面
    goBackItem(){
        this.$emit('goBackItem')
    },
    // 加载项目列表 获取项目名称
    getItemListName(){
        var url = "/api/lampparams/pageJson/"+this.itemId
        this.$http.postObj(url,this.request,(res)=>{
            if(res.success){
                this.projectName = res.data.rows[0].projectName
            }
        })
    }
  },
  watch:{
  },
  components:{
    AddRealityQueryVue,
    RealityQueryDetailPdf
  }
};
</script>
<style lang="scss">
.realityQueryBox{
    box-shadow: 0px 0px 16px 0px rgba(71, 80, 129, 0.1);
    border-radius: 5px;
    padding: 1% 3%;
}
.headerBtnBox{  
    height: 60px;
    padding-left: 22%;
    position: relative;
    background-color: #5a63a3;
    .backBtn{
        position: absolute;
        left: 0;
        font-size: 30px;
        line-height: 60px;
        top: -1px;
        width: 60px;
        height: 60px;
        background-color: #3b437c;
        text-align: center;
        border: none;
        color: #fff;
    }
    button{
        width: 120px;
        border: none;
        background-color: #eaecfd;
        border-radius: 3px;
        color: #333333;
        padding: 0 15px;
        height: 40px;
        line-height: 40px;
        text-align: left;
        position: relative;
        text-align: center;
        margin: 10px 20px;
        font-size: 14px;
    }
    .el-button:focus,.el-button:hover{
        color: #fff;
        border-color: #5a63a3;
        background-color: #5a63a3;
    }

}
.realityQueryBox{
    .el-input{
    width: 85px;
    font-size: 12px;
}
}
.el-form--inline .el-form-item{
    margin-right: 10px;
}
.el-form-item__label{
    padding-right: 5px;
    font-size: 12px;
}
.tableBox th{
    background-color: #f6f7fb;
    color: #555555;
    text-align: center;
}
.tableBox .el-table td{
    text-align: center;
}
.el-table__header .el-table_1_column_1{
    color: #555555;
}
.el-table_1_column_1{
    color: inherit;
}
.operateBtnBox{
    height: 40px;
    margin-bottom: 10px;
    .el-row{
        float: right;
    }
}
.dialog-footer{
    text-align: center;
}
.paddingTop88{
    padding-top: 88px;
}
.marginTop32{
    margin-top: -32px;
}
.projectNameBox{
    font-size: 16px;
    color: #fff;
    position: absolute;
    left: 10%;
    top: 18px;
}
.min20{
    .el-input{
        width: 50px;
    }
}
.min80{
    .el-input{
        width: 90px;
    }
}
.el-input__inner{
    padding: 0 5px;
    height: 30px;
    line-height: 30px;
}

    .headerBtnBox .el-button:focus, .headerBtnBox .el-button:hover{
        color: #fff;
    border-color: #5a63a3;
    background-color: #3b437c;
    }
  .el-table__body tr.current-row>td{
    background: #fff;
  }
  .el-table__body tr.rowStyle>td{
    background: #ECF5FF;
  }
    .rowStyle{
        // background-color:#ECF5FF!important;
    }
    .tableImgBox{
        display: inline-block;
        margin: 0 auto;
        width: 100%;
        .el-carousel__container{
            height: 50px;
        }
        .el-carousel__item.is-active{
            left: 50%;
            margin-left: -20px;
        }
        .el-carousel__arrow--left{
            left: 0;
        }
        .el-carousel__arrow--right{
            right: 0;
        }
    }
    .tableImg{
        width: 40px;
        float: left;
        margin: 1px;
    }
    .dengcanbianhao{
    color: #238fcb;
    cursor: pointer;
    span{
        margin: 5px;
    }
    }
    .activeHeader{
        color: #fff!important;
        border-color: #5a63a3!important;
        background-color: #3b437c!important;
    }
    .el-image-viewer__canvas{
        img{
            margin: 0 auto!important;
        }
    }
</style>